import { EventPriceTypeEnum } from './EventPriceTypeEnum';
import { EventTypeEnum } from './EventTypeEnum';

export interface IEvent {
    id: number;
    name: string;
    showOnWeb: boolean;
    description:string;
    ageGroupId: number;
    roomId: number;
    schoolYear: number;
    lessonLength: number;
    eventTypeId: number;
    priceType: EventPriceTypeEnum;
    price: number;
    firstSemesterPrice: number;
    secondSemesterPrice: number;
    dayOfWeek: number;
    numberOfLessons: number;
    dateOfFirstLesson: Date | string;
    registrationStart: Date | string;
    registrationTime: Date | string;
    maxAge: number;
    minAge: number;
    roomName: string;
    roomDistrict: string;
    ageGroupName: string;
    seets: number;
    seetsTaken: number;
    substitutes: number;
    substitutesTaken: number;
    time: string;
    teacher: string;
    eventTypeEnum: EventTypeEnum
}

export const emptyEvent = (): IEvent => {
    const event: IEvent = {
        ageGroupId: 0,
        description: "",
        eventTypeId: 0,
        id: 0,
        showOnWeb: true,
        lessonLength: 0,
        name: "",
        price: 0,
        firstSemesterPrice: 0,
        secondSemesterPrice: 0,
        priceType: EventPriceTypeEnum.BySemester,
        roomId: 0,
        schoolYear: new Date().getFullYear(),
        dayOfWeek: 0,
        numberOfLessons: 0,
        dateOfFirstLesson: new Date(),
        registrationStart: new Date(),
        registrationTime: new Date('1-1-2024 00:00:00'),
        maxAge: 0,
        minAge: 0,
        ageGroupName: "",
        roomDistrict: "",
        roomName: "",
        seets: 0,
        substitutes: 0,
        time: "",
        seetsTaken: 0,
        substitutesTaken: 0,
        teacher: "",
        eventTypeEnum: EventTypeEnum.Lessons
    }
    return event;
}